/**
 * Карточка — основная единица вёрстки.
 *
 * Группа строк или блок содержимого на белой подложке. Заголовок выносится
 * наружу карточки (как в референсе), чтобы сама карточка начиналась сразу
 * с содержимого и ряды были одинаковой высоты.
 */
import type { ReactNode } from 'react';

import { Icon } from './Icon';
import styles from './Card.module.css';

export function Card({ children, padded = false }: { children: ReactNode; padded?: boolean }) {
  return <div className={padded ? `${styles.card} ${styles.padded}` : styles.card}>{children}</div>;
}

export function GroupCaption({ children }: { children: ReactNode }) {
  return <h2 className={styles.caption}>{children}</h2>;
}

export function GroupNote({ children }: { children: ReactNode }) {
  return <p className={styles.note}>{children}</p>;
}

/** Заголовок группы, по которому открываются подробности. */
export function GroupLink({ children, onClick }: { children: ReactNode; onClick: () => void }) {
  return (
    <button type="button" className={styles.header} onClick={onClick}>
      <span className={styles.caption}>{children}</span>
      <span className={styles.headerChevron}>
        <Icon name="chevron" size={16} />
      </span>
    </button>
  );
}
